import Image from "next/image";
import { useState } from "react";
import classNames from "classnames";

import { SUMMARY_TAB } from "constants/announcementTypes";
import { OutlinedButton } from "components/common/Button/Button";
import MenuIcon from "static/icons/three_dot_menu.svg";
import Chip from "components/common/Chip/Chip";
import CheckIcon from "static/icons/check_without_background.svg";
import useTranslation from "next-translate/useTranslation";
import PartnerProfile from "../../../user/partner/PartnerProfile";
import PartnerUtil from "../../../user/partner/PartnerUtil";
import { HOST } from "../../../config/api";
import { SEARCH_PARTNER_PROFILE } from "../../../constants/routes";
import Link from "next/link";
import { NextRouter, useRouter } from "next/router";

import classes from "./PartnerProfileItem.module.css";
import { useAuth } from "../../../context/auth/AuthContextProvider";

export type Props = {
  data: PartnerProfile;
  announcementItemView?: string;
  onClick?: (id: string) => void;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
  onCancel?: (id: string) => void;
  verified?: boolean;
  isEditable?: boolean;
};

type ExtendedRouter = NextRouter & {
  profileData?: any;
};

export default function PartnerProfileItem({
  data,
  announcementItemView,
  onClick,
  onEdit,
  onDelete,
  onCancel,
  verified,
  isEditable = false,
}: Props) {
  const { user } = useAuth();
  const router = useRouter() as ExtendedRouter;

  const [actionSheetVisible, setActionSheetVisible] = useState(false);

  const onOpenActionSheetHandler = () => setActionSheetVisible(true);
  const onCloseActionSheetHandler = () => setActionSheetVisible(false);
  const { t } = useTranslation("common");
  const id = data._id;
  const location = PartnerUtil.getFullAddress(data);

  const { photos, serviceCategory } = data;
  const imageURL = photos?.[0]?.filename
    ? `${HOST}/img/${photos?.[0]?.filename}`
    : photos?.[0]?.url || "";

  const priceFromText = PartnerUtil.getPriceFromText(data);
  const isPaid = PartnerUtil.isPaid(user);

  return (
    <>
      <li className={classes.announcementItem}>
        <Link
          href={{
            pathname: `${SEARCH_PARTNER_PROFILE}/${id}`,
          }}
          as={`${SEARCH_PARTNER_PROFILE}/${id}`}
          passHref
        >
          <a
            onClick={() => {
              router.push(
                {
                  pathname: `${SEARCH_PARTNER_PROFILE}/${id}`,
                },
                undefined,
                { shallow: true }
              );
              router.profileData = data;
            }}
            className={classNames(classes.linkContainer)}
          >
            <div
              // onClick={() => onClickAnnouncement?.call(this, id)}
              className={classNames(classes.mainSection, {
                [classes.clickable]: typeof onClick === "function",
              })}
            >
              <div className={classes.imageContainer}>
                {/*eslint-disable-next-line @next/next/no-img-element */}
                <img src={imageURL} alt="" className={classes.image} />
                {verified && (
                  <Chip className={classes.chip}>
                    <span className={classes.chipContentContainer}>
                      <span>
                        <Image src={CheckIcon} alt="" layout="responsive" />
                      </span>
                      {t("verified")}
                    </span>
                  </Chip>
                )}
              </div>
              <div className={classes.info}>
                <div className={classes.description}>
                  <div className={classes.contactData}>
                    <h3>{data.name}</h3>
                    <span className={classes.location}>{location}</span>
                  </div>
                  {serviceCategory ? (
                    <span className={classes.massageType}>
                      {t(`service_category.${serviceCategory}`)}
                    </span>
                  ) : null}
                </div>
                <div className={classes.price}>
                  <div>
                    {priceFromText ? (
                      <>
                        <span className={classes.from}>{t("from")} </span>
                        <span className={classes.amount}>{priceFromText}</span>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            {/*{announcementItemView === SUMMARY_TAB && (*/}
            {/*  <>*/}
            {/*    <div*/}
            {/*      className={classNames(*/}
            {/*        classes.additionalSection,*/}
            {/*        classes.buttonsPanel*/}
            {/*      )}*/}
            {/*    >*/}
            {/*      {buttonsPanelContent}*/}
            {/*      <FilledButton*/}
            {/*        content={t("extend")}*/}
            {/*        type="button"*/}
            {/*        className={classes.button}*/}
            {/*        onClick={() => onExtendAnnouncement?.call(this, id)}*/}
            {/*      />*/}
            {/*    </div>*/}
            {/*    {actionSheetVisible && (*/}
            {/*      <ActionSheet onCloseHandler={onCloseActionSheetHandler}>*/}
            {/*        <ActionItem*/}
            {/*          text="extend"*/}
            {/*          onClickHandler={() =>*/}
            {/*            onExtendAnnouncement?.call(this, id)*/}
            {/*          }*/}
            {/*        />*/}
            {/*        <ActionItem*/}
            {/*          text="edit"*/}
            {/*          onClickHandler={() => onEditAnnouncement?.call(this, id)}*/}
            {/*        />*/}
            {/*        <ActionItem*/}
            {/*          text="duplicate"*/}
            {/*          onClickHandler={() =>*/}
            {/*            onDuplicateAnnouncement?.call(this, id)*/}
            {/*          }*/}
            {/*        />*/}
            {/*        <ActionItem*/}
            {/*          text="hide"*/}
            {/*          onClickHandler={() => onOpenModal?.call(this, id, "hide")}*/}
            {/*        />*/}
            {/*        <ActionItem*/}
            {/*          text="delete"*/}
            {/*          onClickHandler={() =>*/}
            {/*            onOpenModal?.call(this, id, "remove")*/}
            {/*          }*/}
            {/*          critical*/}
            {/*        />*/}
            {/*      </ActionSheet>*/}
            {/*    )}*/}
            {/*  </>*/}
            {/*)}*/}

            {/*{announcementItemView === CALENDAR_TAB && (*/}
            {/*  <>*/}
            {/*    <div*/}
            {/*      className={classNames(*/}
            {/*        classes.additionalSection,*/}
            {/*        classes.buttonsPanel*/}
            {/*      )}*/}
            {/*    >*/}
            {/*      {buttonsPanelContent}*/}
            {/*      <FilledButton*/}
            {/*        content={t("activate")}*/}
            {/*        type="button"*/}
            {/*        onClick={() => onActivateAnnouncement?.call(this, id)}*/}
            {/*        className={classes.button}*/}
            {/*      />*/}
            {/*    </div>*/}
            {/*    {actionSheetVisible && (*/}
            {/*      <ActionSheet onCloseHandler={onCloseActionSheetHandler}>*/}
            {/*        <ActionItem*/}
            {/*          text="activate"*/}
            {/*          onClickHandler={() =>*/}
            {/*            onActivateAnnouncement?.call(this, id)*/}
            {/*          }*/}
            {/*        />*/}
            {/*        <ActionItem*/}
            {/*          text="edit"*/}
            {/*          onClickHandler={() => onEditAnnouncement?.call(this, id)}*/}
            {/*        />*/}
            {/*        <ActionItem*/}
            {/*          text="duplicate"*/}
            {/*          onClickHandler={() =>*/}
            {/*            onDuplicateAnnouncement?.call(this, id)*/}
            {/*          }*/}
            {/*        />*/}
            {/*        <ActionItem*/}
            {/*          text="delete"*/}
            {/*          onClickHandler={() => onOpenModal?.call(this, id, "remove")}*/}
            {/*          critical*/}
            {/*        />*/}
            {/*      </ActionSheet>*/}
            {/*    )}*/}
            {/*  </>*/}
            {/*)}*/}
          </a>
        </Link>
      </li>

      {isEditable ? (
        <div
          className={classNames(
            classes.additionalSection,
            classes.buttonsPanel
          )}
        >
          {isPaid ? (
            <div className={classes.mr}>
              <OutlinedButton
                content={t("cancel_subscription")}
                type="button"
                onClick={() => onCancel && onCancel(id)}
                className={classNames(classes.button, classes.outlinedButton)}
              />
            </div>
          ) : null}
          <div className={classes.mr}>
            <OutlinedButton
              content={t("edit")}
              type="button"
              onClick={() => onEdit && onEdit(id)}
              className={classNames(classes.button, classes.outlinedButton)}
            />
          </div>
          <OutlinedButton
            content={t("delete")}
            type="button"
            onClick={() => onDelete && onDelete(id)}
            className={classNames(classes.button, classes.outlinedButton)}
          />
        </div>
      ) : null}
    </>
  );
}
